/**
 * Join-Adresse fuer "Verbinden mit IP": nutzt der Server den Standard-Port des
 * Spiels, OHNE ":port" anzeigen - Clients ergaenzen ihn selbst, und "host:7777"
 * passte bei ARK beim Einfuegen nicht. Abweichende Ports bleiben sichtbar
 * (sonst landet man auf der falschen Instanz).
 */
export const joinAddress = (host: string, port?: number | null, defaultPort?: number | null): string =>
  port && port !== defaultPort ? `${host}:${port}` : host;
